import Layout from "../components/Layout";
import { InventoryRequest } from "../components/_Inventory/InventoryRequest";

const InventoryRequestPage = (props: any) => {
    return (
        <Layout>
            <InventoryRequest />
        </Layout>
    )
}

export default InventoryRequestPage